import { Common } from '@thecvlb/design-system/lib/src';

import { ReducedSignupStepProps } from 'containers/SignUp/Content/content.types';
import StaticReviewsList from 'widgets/reviews/StaticReviewsList';

import { DUMMY_REVIEWS_WM } from '../SelectPlan/selectPlan.settings';

import MoneyBack from 'assets/images/signUp/wm-money-back.svg?react';

const MarketingMoneyBackGuarantee: React.FC<ReducedSignupStepProps> = ({ moveToStep }) => {
  return (
    <div className="flex flex-col items-center gap-6">
      <MoneyBack className="w-[200px]" />
      <div className="mx-auto flex max-w-[500px] flex-col gap-2 text-center text-primary-700">
        <h3 className="text-2xl font-bold md:text-m2xl" data-testid="header">
          You have nothing to lose, except those extra pounds.
        </h3>
        <p>
          We’re so confident you’ll succeed with LifeMD that if you participate in our Weight
          Management Program and don’t lose at least 10% of your body weight, you’ll be eligible for
          a refund.
        </p>
      </div>
      <div className="max-w-full">
        <StaticReviewsList reviews={DUMMY_REVIEWS_WM} />
      </div>
      <Common.Button color="blue" fullWidthOnMobile onClick={() => moveToStep('next')}>
        Continue
      </Common.Button>
    </div>
  );
};

export default MarketingMoneyBackGuarantee;
